export const routes = {
  code: "/code",
  index: "/",
  android: "/android",
  ios: "/ios",
  emailLogin: "/login/email",
  resetPassword: "/resetPassword",
  phoneNumberLogin: "/login/phone",
  result: "/result",
};
